import React, { useLayoutEffect, useState } from "react";

import { proper } from "lib/common";
import { ReactComponent as Dropdown } from "assets/dropdown_icon_open.svg";

import {
  useRecoilState,
  useRecoilValueLoadable,
  useSetRecoilState,
} from "recoil";
import {
  asyncGetCategory,
  asyncGetCategoryDetail,
  categoryState,
} from "lib/store/project";
import { modalState } from "lib/store/common";

import { Button, Radio, Modal } from "@atsent/components";

import { Label } from "components/atom/Label";

import "./CategorySelect.scss";

export type CategorySelectProps = {
  close: any;
  onClick: any;
};

type AccordionProps = {
  cate: {
    key: string;
    value: string;
  };
  idx: number;
  isOpen: boolean;
};

const Accordion: React.FC<AccordionProps> = ({ cate, idx, isOpen = false }) => {
  const setCategory = useSetRecoilState(categoryState);
  const { state, contents } = useRecoilValueLoadable(
    asyncGetCategoryDetail({ category: cate.key })
  );
  useLayoutEffect(() => {
    if (isOpen && state === "hasValue") {
      setCategory((d) =>
        d.map((i, num) => (num !== idx ? i : { ...i, elements: contents }))
      );
    }
    // eslint-disable-next-line
  }, [isOpen, state]);

  return (
    <div className="accordion" key={cate.key}>
      <div className={`title ${isOpen}`}>
        <Radio
          label={proper(cate.value)}
          value={cate.value}
          name={"selector"}
          checked={idx === 0}
          inline
        />
        <Dropdown />
      </div>
      {isOpen && (
        <div className="body">
          <span>분석요소</span>
          <div className="label-wrapper">
            {state === "hasValue" &&
              contents.map((i: string) => (
                <Label key={`${i}-${idx}`}>{i}</Label>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};
export const CategorySelect: React.FC<CategorySelectProps> = ({
  close,
  onClick,
}) => {
  const setModal = useSetRecoilState(modalState);
  const [list, setList] = useRecoilState(categoryState);
  const [select, setSelect] = useState({ key: "", value: "" });
  const { state, contents } = useRecoilValueLoadable(asyncGetCategory);

  useLayoutEffect(() => {
    if (state === "hasValue") {
      setList(contents);
      setSelect(contents[0]);
    }
    // eslint-disable-next-line
  }, [state]);

  return (
    <Modal
      close={close}
      cx={"CategorySelect"}
      title={"분석할 구문의 카테고리를 선택해주세요."}
    >
      <form
        onChange={(e: any) =>
          setSelect(contents.find((i: any) => i.value === e.target.value))
        }
        style={{
          gridTemplateRows: `repeat(${(state === "hasValue"
            ? 2
            : contents.length / 2
          ).toFixed(0)},90px)`,
        }}
      >
        {list.map((cate: { key: string; value: string }, idx) => (
          <Accordion
            cate={cate}
            idx={idx}
            key={`category-list-${idx}`}
            isOpen={cate.key === select.key}
          />
        ))}
      </form>
      <div className="button-wrapper">
        <span
          className={"category-want"}
          onClick={() =>
            setModal((_) => ({
              ..._,
              categorySelect: false,
              requestCategory: true,
            }))
          }
        >
          원하는 카테고리가 없으신가요?
        </span>
        <Button click={() => onClick(select)} cx={"center black"}>
          선택
        </Button>
      </div>
    </Modal>
  );
};
